import NoResult from "assets/images/common/no-result.png"
import Image, { type StaticImageData } from "next/image"
import { useTranslation } from "react-i18next"
import { useIsMobile } from "@/hooks/use-mobile"

interface EmptyProps {
	src?: StaticImageData
	title: string
}

const Empty: React.FC<EmptyProps> = ({ src, title }) => {
	const { t } = useTranslation()
	const isMobile = useIsMobile()

	return (
		<div
			className={`flex flex-col items-center justify-center text-center ${
				isMobile ? "p-6 h-[40vh] min-h-50" : "p-4 h-[50vh]"
			}`}
		>
			<div className="relative size-15 md:size-18">
				<Image
					src={src || NoResult}
					alt={title || t("common.noResult")}
					fill
					className="object-contain"
					priority // Optional: if the image is above the fold
					sizes="(max-width: 768px) 100vw, 50vw"
				/>
			</div>
			{title && (
				<p
					className={`mt-4 font-['DINPro-Regular'] font-normal text-black ${
						isMobile ? "text-sm" : "text-base"
					}`}
				>
					{title}
				</p>
			)}
		</div>
	)
}

export default Empty
